import { message } from "antd";
import axios from "../../axios";
import config from "../../config";
import { isEmpty } from "lodash";
import UserServices from "../../services/UserServices";
import { usePersistedStore } from "../persisted-store";
import { businessInitialValues, usersInitialValues } from "../../constants/store-initial-values";
import { useGeneralStore } from "./createGeneralSlice";

export const createBusinessSlice = (set, get) => ({
    business: {
        businesses: {
            loading: false,
            all: [],
            single: {},
            byToken: {},
            selected: {},
            selectedHeads: [],
            selectedHead: {},
            roles: [],
            defaultAgentWage: [],
            filtered: [],
            filteredSeo: [],
            isError: false,
        },
        branchNames: {
            loading: false,
            data: [],
        },
        currentBusiness: {
            loading: false,
            token: null,
            fundBalanceData: [],
            name: ""
        },
        companyNames: {
            loading: false,
            data: []
        },
        companyFeedback: {
            loading: false,
            data: [],
        },
        wages: {
            loading: false,
            single: null,
        },
        agentPaid: {},
    },

    getBranchNames: async (token) => {
        set(state => ({
            business: {
                ...state.business,
                branchNames: { ...state.business.branchNames, loading: true }
            }
        }));
        try {
            const res = await axios({
                method: 'post',
                baseURL: config.apiUrls(),
                url: '/v1/business/business-branchs',
                headers: { token }
            });
            set(state => ({
                business: {
                    ...state.business,
                    branchNames: { loading: false, data: res.data }
                }
            }));
        } catch (error) {
            set(state => ({
                business: {
                    ...state.business,
                    branchNames: { ...state.business.branchNames, loading: false }
                }
            }));
        }
    },

    setCurrentBusinessName: (name) => set(state => ({
        business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, name } }
    })),

    setCurrentBusinessId: (id) => set(state => ({
        business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, id } }
    })),

    setCurrentBusiness: (data) => set(state => ({
        business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, data: data } }
    })),

    getBusinessSettlementMethod: async () => {
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, loading: true } } }));
        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `v1/business/Fund-Balance`,
                headers: { token }
            });
            set(state => ({
                business: {
                    ...state.business,
                    currentBusiness: {
                        ...state.business.currentBusiness,
                        loading: false,
                        fundBalanceData: resp.data
                    }
                }
            }));
        } catch (error) {
            set(state => ({ business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, loading: false } } }));
        }
    },

    getCompanyNames: async (token) => {
        set(state => ({
            business: {
                ...state.business,
                companyNames: { ...state.business.companyNames, loading: true }
            }
        }));
        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: '/v1/business/userCompany',
                headers: { token }
            });
            set(state => ({
                business: {
                    ...state.business,
                    companyNames: { loading: false, data: resp.data }
                }
            }));
        } catch (error) {
            set(state => ({
                business: {
                    ...state.business,
                    companyNames: { ...state.business.companyNames, loading: false }
                }
            }));
        }
    },

    getCompanyFeedback: async () => {
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, companyFeedback: { ...state.business.companyFeedback, loading: true } } }));
        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: '/v1/company/feedback/waiting',
                headers: { token }
            });
            set(state => ({ business: { ...state.business, companyFeedback: { loading: false, data: resp.data } } }));
        } catch (error) {
            set(state => ({ business: { ...state.business, companyFeedback: { ...state.business.companyFeedback, loading: false, data: [] } } }));
        }
    },

    postCompanyFeedback: async (params) => {
        const { StatusId, Id } = params;
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, companyFeedback: { ...state.business.companyFeedback, loading: true } } }));
        try {
            await axios({
                method: 'post',
                baseURL: config.apiUrls(),
                url: `/v1/company/feedback/${Id}/status`,
                data: { StatusId },
                headers: { token }
            });
            set(state => ({ business: { ...state.business, companyFeedback: { ...state.business.companyFeedback, loading: false } } }));
            get().getCompanyFeedback();
        } catch (error) {
            set(state => ({ business: { ...state.business, companyFeedback: { ...state.business.companyFeedback, loading: false } } }));
        }
    },
    getDefaultAgentWagePerId: async (branchId) => {
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, wages: { ...state.business.wages, loading: true } } }));
        try {
            const res = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/default-agent-wage/branchId/${branchId}`,
                headers: { token }
            });
            set(state => ({ business: { ...state.business, wages: { loading: false, single: res.data } } }));
        } catch (error) {
            set(state => ({ business: { ...state.business, wages: { ...state.business.wages, loading: false } } }));
        }
    },

    getAgentsWagePaid: async (params) => {
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, agentPaid: { ...state.business.agentPaid, loading: true } } }));
        try {
            const resp = await axios({
                method: 'post',
                baseURL: config.apiUrls(),
                url: '/v1/business/get-agent-wage-paid',
                data: {
                    UserName: params.userName,
                    FromPayDate: params.fromDate,
                    ToPayDate: params.toDate
                },
                headers: { token }
            });
            set(state => ({ business: { ...state.business, agentPaid: { loading: false, paidList: resp.data } } }));
        } catch (error) {
            set(state => ({ business: { ...state.business, agentPaid: { ...state.business.agentPaid, loading: false } } }));
        }
    },

    postAgentWagePaid: async (param) => {
        const { params, cb } = param;
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, agentPaid: { ...state.business.agentPaid, loading: true } } }));
        try {
            await axios({
                method: 'post',
                baseURL: config.apiUrls(),
                url: '/v1/business/add-agent-wage-paid',
                data: params,
                headers: { token }
            });
            set(state => ({ business: { ...state.business, agentPaid: { ...state.business.agentPaid, loading: false } } }));
            cb();
        } catch (error) {
            set(state => ({ business: { ...state.business, agentPaid: { ...state.business.agentPaid, loading: false } } }));
        }
    },

    getBusinesses: async () => {
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const res = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/businesses`
            });
            const businessesObj = res.data.reduce((obj, business) => {
                obj[business.token] = business;
                return obj;
            }, {});
            set(state => ({
                business: {
                    ...state.business,
                    businesses: {
                        ...state.business.businesses,
                        loading: false,
                        all: businessesObj
                    }
                }
            }));
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
            // Handle logout differently in Zustand
        }
    },


    putBusiness: async (params) => {
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const res = await axios({
                method: 'put',
                baseURL: config.apiUrls(),
                url: `/v1/business/business`,
                headers: { "Content-Type": "application/json;charset=UTF-8" },
                data: params
            });

            if (res && res?.status === 200) {
                set(state => ({
                    business: {
                        ...state.business,
                        businesses: {
                            ...state.business.businesses,
                            loading: false,
                            single: res.data
                        }
                    }
                }));
                try {
                    await axios({
                        method: 'post',
                        baseURL: config.api.localApi,
                        url: `/redis-del-bykey`,
                        headers: { "Content-Type": "application/json;charset=UTF-8" },
                        data: { key: 'business', host: params?.domain }
                    });
                    useGeneralStore.getState().NotifSuccess('شریک تجاری با موفقیت بروزرسانی شد');
                } catch (error) {

                }
            }
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    postBusinessStyles: async (params, updatedBusinessToken, sourceBusinessToken) => {
        const Authorization = get().auth.userToken;
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const res = await axios({
                method: 'post',
                baseURL: config.api.localApi,
                url: '/business/compile',
                headers: {
                    "apiurl": config.apiUrls(),
                    "Authorization": `Bearer ${Authorization}`,
                    "Content-Type": "application/json;charset=UTF-8",
                    "business-token": sourceBusinessToken
                },
                data: {
                    updatedBusinessToken: updatedBusinessToken,
                    styles: params.styles
                }
            });
            if (res && res?.status === 200) {
                const styles = {
                    ...params.styles,
                    ant: res?.less,
                    custom: res?.custom
                };
                // Only update the styles in the state, not the entire business object
                set(state => ({
                    business: {
                        ...state.business,
                        businesses: {
                            ...state.business.businesses,
                            loading: false,
                            single: {
                                ...state.business.businesses.single,
                                styles: styles
                            }
                        }
                    }
                }));
                try {
                    useGeneralStore.getState().NotifSuccess('استایل‌ها با موفقیت بروزرسانی شد');
                } catch (error) {

                }

            }
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },
    getBusiness: async (businessId) => {
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const res = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/business/${businessId}`,
            });
            set(state => ({
                business: {
                    ...state.business,
                    businesses: {
                        ...state.business.businesses,
                        loading: false,
                        single: res.data
                    }
                }
            }));
        } catch (error) {
            set(state => ({
                business: {
                    ...state.business,
                    businesses: {
                        ...state.business.businesses,
                        loading: false,
                        isError: true
                    }
                }
            }));
        }
    },

    deleteBusiness: async (param) => {
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const res = await axios({
                method: 'delete',
                baseURL: config.apiUrls(),
                url: `/v1/business/business/${param.id}`
            });
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
            message.success(res.message);
            get().getBusinesses();
        } catch (error) {
            message.error(error.message);
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    getcurrentBusinessBytoken: async (businessToken, source) => {
        set(state => ({ business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, loading: true }, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/business/token/${businessToken}`,
            });
            set(state => ({ business: { ...state.business, currentBusiness: { data: resp.data, name: resp.data.name, token: resp?.data?.token, loading: false }, businesses: { ...state.business.businesses, byToken: { ...resp.data, source }, loading: false } } }));
        } catch (error) {
            set(state => ({ business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, loading: false }, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    getBusinessBytoken: async (businessToken, source) => {
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/business/token/${businessToken}`,
            });
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, byToken: { ...resp.data, source }, loading: false } } }));
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },


    setCurrentBusinessToken: (token) => set(state => ({ business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, token } } })),

    getUserBusinessesAc: async () => {
        const store = usePersistedStore.getState();
        const { auth, business, users } = store;
        const userInfo = auth?.userInfo;
        const BsToken = auth.userInfo?.BusinessToken;
        const userBusinesses = users.businesses;
        const businessByToken = business.businesses?.byToken;
        let userResources = userInfo?.Resources;
        let permission = userResources?.includes("access_to_sub_businesses");

        if (permission && isEmpty(userBusinesses)) {
            try {
                const resp = await UserServices.getUserBusinesses(BsToken);
                set(state => ({ users: { ...state.users, businesses: resp.data.Businesses } }));

                const userBsns = resp.data.Businesses;
                const token = userBsns[0].Token;
                const name = userBsns[0].Title;
                const id = userBsns[0].Id;

                if (isEmpty(businessByToken)) {

                    get().getcurrentBusinessBytoken(token, "user");
                }

                set(state => ({
                    business: { ...state.business, currentBusiness: { ...state.business.currentBusiness, token, name, id } }
                }));
                // afterPromise()
                // if (!isEmpty(userBsns) && !isEmpty(getAccounts(all))) {
                //     const availables = userBsns
                //         .map(item => getAccounts(all).find(i => i.token === item.Token))
                //         .filter(Boolean);
                //     // You might want to do something with availables here
                // }
            } catch (error) {
                if (error.response.status === 401 || error.response.status === 440) {
                    usePersistedStore.getState().logOut()
                }
                // Handle logout
            }
        } else if (!permission) {
            const token = userInfo.BusinessToken;
            set(state => ({
                business: {
                    ...state.business,
                    currentBusiness: {
                        ...state.business.currentBusiness,
                        token
                    }
                }
            }));
            get().getBusinessBytoken(token, "user");
        }
    },

    getBusinessRole: async () => {
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: '/v1/business/role',
                headers: { token }
            });
            set(state => ({
                business: {
                    ...state.business,
                    businesses: {
                        ...state.business.businesses,
                        loading: false,
                        roles: resp.data
                    }
                }
            }));
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    getDefaultAgentWage: async () => {
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/default-agent-wage/branchId/null`,
                headers: { token }
            });
            set(state => ({
                business: {
                    ...state.business,
                    businesses: {
                        ...state.business.businesses,
                        loading: false,
                        defaultAgentWage: resp.data
                    }
                }
            }));
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    putDefaultAgentWage: async (param) => {
        const { data, reset } = param;
        const token = get().business.currentBusiness.token;
        try {
            await axios({
                method: 'put',
                baseURL: config.apiUrls(),
                url: '/v1/business/default-agent-wage',
                data,
                headers: { token }
            });
            get().getDefaultAgentWage();
            reset();
        } catch (error) {
            // Handle error
        }
    },

    getNewWhitelabeles: async () => {
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const resp = await axios({
                method: 'post',
                baseURL: config.apiUrls(),
                url: '/v1/business/SyncNewBusinesses',
                headers: { token }
            });
            set(state => ({
                business: {
                    ...state.business,
                    businesses: {
                        ...state.business.businesses,
                        loading: false,
                        all: { ...state.business.businesses.all, [resp.data.token]: resp.data }
                    }
                }
            }));
            get().getBusinesses();
            // Handle NotifSuccess
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    updateOneBusiness: async (businessToken) => {
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const resp = await axios({
                method: 'post',
                baseURL: config.apiUrls(),
                url: `v1/business/SyncBusiness/token/${businessToken}`
            });
            if (resp.status === 200) {
                set(state => ({
                    business: {
                        ...state.business,
                        businesses: {
                            ...state.business.businesses,
                            loading: false,
                            all: { ...state.business.businesses.all, [resp.data.data.token]: resp.data.data }
                        }
                    }
                }));
                // Handle NotifSuccess
            }
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    filterBussiness: (param) => {
        const { value, all } = param;
        const payload = value ? all.filter(item => {
            return (item.name && item.name.includes(value)) ||
                (item.domain && item.domain.includes(value)) ||
                (item.token && item.token.includes(value));
        }) : all;
        set(state => ({
            business: {
                ...state.business,
                businesses: {
                    ...state.business.businesses,
                    filtered: payload
                }
            }
        }));
    },

    postHead: async (param) => {
        const { params, type, businessToken, cb } = param;
        const token = get().business.currentBusiness.token;

        if (!businessToken) return;
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));

        try {
            let resp;
            if (type === 'post') {
                resp = await axios({
                    method: 'post',
                    baseURL: config.apiUrls(),
                    url: `/v1/business/head/token/${businessToken}`,
                    data: params,
                    headers: { token }
                });
            } else {
                resp = await axios({
                    method: 'put',
                    baseURL: config.apiUrls(),
                    url: `/v1/business/head`,
                    data: params,
                    headers: { token }
                });
            }
            if (resp) {
                get().getBusinessHeads(businessToken);
                if (cb) {
                    cb();
                }
            } else {
                useGeneralStore.getState().NotifError(resp?.data?.message)
            }
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    deleteHead: async (param) => {
        const { headId, businessId } = param;
        const token = get().business.currentBusiness.token;

        if (!businessId) return;

        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));
        try {
            const resp = await axios({
                method: 'delete',
                baseURL: config.apiUrls(),
                url: `/v1/business/head/${headId}`,
                headers: { token }
            });

            if (resp.data.success) {
                get().getBusinessHeads(businessId);
                useGeneralStore.getState().NotifSuccess('اطلاعات سئو شریک تجاری با موفقیت حذف شد');
                // Handle NotifSuccess
            } else {
                useGeneralStore.getState().NotifError(resp.data.message)

                // Handle NotifError
            }
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },

    getBusinessHeads: async (businessToken) => {
        const token = get().business.currentBusiness.token;
        set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: true } } }));

        try {
            const resp = await axios({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/business/head/token/${businessToken}`,
                headers: { token }
            });
            set(state => ({
                business: {
                    ...state.business,
                    businesses: {
                        ...state.business.businesses,
                        loading: false,
                        selectedHeads: resp.data.data,
                        filteredSeo: resp.data.data,
                    }
                }
            }));
        } catch (error) {
            set(state => ({ business: { ...state.business, businesses: { ...state.business.businesses, loading: false } } }));
        }
    },
    // Arvan related actions
    subDomainExists: async (dnsName) => {
        if (!dnsName) return false;
        try {
            const token = get().business.currentBusiness.token;

            const resp = await axios({
                method: 'POST',
                baseURL: config.apiUrls(),
                url: `/v1/cdn/is-exist-dns`,
                headers: { token },
                data: { dnsName }
            });

            // Return the actual existence status from response
            return resp?.data;

        } catch (error) {
            return false;
        }
    },

    addSubDomains: async (subdomainPrefixes) => {
        if (!subdomainPrefixes || subdomainPrefixes.length === 0) return;

        try {
            const token = get().business.currentBusiness.token;

            // Process all subdomains in parallel
            const results = await Promise.allSettled(
                subdomainPrefixes.map(async (prefix) => {
                    const exists = await get().subDomainExists(prefix);

                    if (!exists) {
                        const resp = await axios({
                            method: 'POST',
                            baseURL: config.apiUrls(),
                            url: `/v1/cdn/add-dns`,
                            headers: { token },
                            data: { dnsName: prefix }  // Send only prefix (x, not x.bimeh.com)
                        });
                        return { dnsName: prefix, success: true, data: resp.data };
                    } else {
                        return { dnsName: prefix, success: false, reason: 'exists' };
                    }
                })
            );

            // Count successes and failures
            const successful = results.filter(r => r.status === 'fulfilled' && r.value.success);
            const alreadyExists = results.filter(r => r.status === 'fulfilled' && !r.value.success);
            const failed = results.filter(r => r.status === 'rejected');

            // Show appropriate notifications
            if (successful.length > 0) {
                useGeneralStore.getState().NotifSuccess(
                    `${successful.length} ساب‌دامین با موفقیت اضافه شد`
                );
            }

            if (alreadyExists.length > 0) {
                useGeneralStore.getState().NotifWarning(
                    `${alreadyExists.length} ساب‌دامین قبلاً وجود داشت`
                );
            }

            if (failed.length > 0) {
                useGeneralStore.getState().NotifError(
                    `${failed.length} ساب‌دامین با خطا مواجه شد`
                );
            }

            return { successful, alreadyExists, failed };

        } catch (error) {
            console.error("Error adding subdomains:", error);
            useGeneralStore.getState().NotifError("خطا در اضافه کردن ساب‌دامین‌ها");
            throw error;
        }
    },

    deleteSubDomains: async (subdomainPrefixes) => {
        if (!subdomainPrefixes || subdomainPrefixes.length === 0) return;

        try {
            const token = get().business.currentBusiness.token;

            const results = await Promise.allSettled(
                subdomainPrefixes.map(async (prefix) => {
                    const exists = await get().subDomainExists(prefix);

                    if (exists) {
                        const resp = await axios({
                            method: 'POST',
                            baseURL: config.apiUrls(),
                            url: `/v1/cdn/remove-dns`,
                            headers: { token },
                            data: { dnsName: prefix }
                        });
                        return { dnsName: prefix, success: true, data: resp.data };
                    } else {
                        return { dnsName: prefix, success: false, reason: 'not_exists' };
                    }
                })
            );

            const successful = results.filter(r => r.status === 'fulfilled' && r.value.success);
            const notFound = results.filter(r => r.status === 'fulfilled' && !r.value.success);
            const failed = results.filter(r => r.status === 'rejected');

            if (successful.length > 0) {
                useGeneralStore.getState().NotifSuccess(
                    `${successful.length} ساب‌دامین با موفقیت حذف شد`
                );
            }
            if (notFound.length > 0) {
                useGeneralStore.getState().NotifWarning(
                    `${notFound.length} ساب‌دامین در Arvan یافت نشد`
                );
            }
            if (failed.length > 0) {
                useGeneralStore.getState().NotifError(
                    `${failed.length} ساب‌دامین با خطا مواجه شد`
                );
            }

            return { successful, notFound, failed };

        } catch (error) {
            console.error("Error deleting subdomains:", error);
            useGeneralStore.getState().NotifError("خطا در حذف ساب‌دامین‌ها");
            throw error;
        }
    },

    clearCDNCaches: async (domainNames) => {
        if (!domainNames || domainNames.length === 0) return;

        try {
            const token = get().business.currentBusiness.token;

            const results = await Promise.allSettled(
                domainNames.map(async (domainName) => {
                    const resp = await axios({
                        method: 'POST',
                        baseURL: config.apiUrls(),
                        url: `/v1/cdn/purge-cdn-cache/all`,
                        headers: { token },
                        data: { domainName }
                    });
                    return { domainName, success: true, data: resp.data };
                })
            );

            const successful = results.filter(r => r.status === 'fulfilled' && r.value.success);
            const failed = results.filter(r => r.status === 'rejected');

            if (successful.length > 0) {
                useGeneralStore.getState().NotifSuccess(
                    `کش ${successful.length} دامنه با موفقیت پاک شد`
                );
            }
            if (failed.length > 0) {
                useGeneralStore.getState().NotifError(
                    `${failed.length} دامنه با خطا مواجه شد`
                );
            }

            return { successful, failed };

        } catch (error) {
            console.error("Error clearing CDN caches:", error);
            useGeneralStore.getState().NotifError("خطا در پاک‌سازی کش CDN");
            throw error;
        }
    },
    // end of arvan related actions

    filterSeo: (param) => {
        const { value, all } = param;
        const searchedValue = value.toLowerCase();
        const payload = searchedValue ? all?.filter(item => {
            return (item.url && item.url.toLowerCase().includes(searchedValue)) ||
                (item.title && item.title.toLowerCase().includes(searchedValue));
        }) : all;
        set(state => ({
            business: {
                ...state.business,
                businesses: {
                    ...state.business.businesses,
                    filteredSeo: payload
                }
            }
        }));
    },
    setSelectedHead: (selectedHead) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                selectedHead
            }
        }
    })),

    selectBusiness: (selected) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                selected
            }
        }
    })),

    setBusinessHeads: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                selectedHeads: payload,
                filteredSeo: payload
            }
        }
    })),

    setBusinesses: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                all: payload.reduce((obj, business) => {
                    obj[business.token] = business;
                    return obj;
                }, {})
            }
        }
    })),

    updateWhiteLabels: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                all: payload.reduce((obj, business) => {
                    obj[business.token] = business;
                    return obj;
                }, {})
            }
        }
    })),

    addNewWhiteLabel: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                all: { ...state.business.businesses.all, [payload.token]: payload }
            }
        }
    })),

    updateWhiteLabel: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                all: { ...state.business.businesses.all, [payload.token]: payload }
            }
        }
    })),

    setBusinessSuccess: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                single: payload
            }
        }
    })),

    setBusinessNewSuccess: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                single: payload
            }
        }
    })),

    filterBusiness: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                filtered: payload
            }
        }
    })),

    // filterSeo: (payload) => set(state => ({
    //     business: {
    //         ...state.business,
    //         businesses: {
    //             ...state.business.businesses,
    //             filteredSeo: payload
    //         }
    //     }
    // })),

    setBusinessRoles: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                roles: payload
            }
        }
    })),

    setDefaultAgentWages: (payload) => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                defaultAgentWage: payload
            }
        }
    })),

    startBusinessLoading: () => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: true,
                isError: false
            }
        }
    })),

    startBusinessNewLoading: () => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: true,
                isError: false
            }
        }
    })),

    stopBusinessLoading: () => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false
            }
        }
    })),

    stopBusinessNewLoading: () => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false
            }
        }
    })),

    setErrorLoadBusiness: () => set(state => ({
        business: {
            ...state.business,
            businesses: {
                ...state.business.businesses,
                loading: false,
                isError: true
            }
        }
    })),
    RESET_APP_BUSINESS_USERS: () => set(() => ({ business: businessInitialValues, users: usersInitialValues })),
});
